<template>
  <!-- main col -->
  <v-col class="pa-0">
    <!-- Title EventDetails_AuctionProductList -->
    <h3 class="primary--text">{{$translate('PRODUCTS')}}</h3>
    <!-- EventDetails_AuctionProductList -->
    <EventDetails_AuctionProductList
      :eventDetails="eventDetails"
    ></EventDetails_AuctionProductList>
    <!-- EventDetails_AuctionApp -->
    <EventDetails_AuctionApp
      :eventDetails="eventDetails"
    ></EventDetails_AuctionApp>
  </v-col>
</template>

<script>
  import EventDetails_AuctionProductList from './EventDetails_AuctionProductList';
  import EventDetails_AuctionApp from './EventDetails_AuctionApp';
  export default {
    name: 'EventDetails_Auction',
    components: {
      EventDetails_AuctionProductList,
      EventDetails_AuctionApp,
    },
    props: {
      eventDetails: Object,
    },
    data() {
      return {
      };
    },
    watch: {
    },
    methods: {
    },
  };
</script>

<style scoped>

</style>
